
export enum DrawFont {
  Arial = 0,
  Verdana = 1,
  Calibri = 2,
  Tahoma = 3
}
export enum FontStyle {
  Regular = 0,
  Bold = 1,
  Italic = 2,
  Underline = 3,
  Strikethrough = 4
}
export enum AnnStrokeLineCap {
  Flat = 0,
  Square = 1,
  Round = 2,
  Triangle = 3
}
export enum Shapes {
  None = 0,
  Rectangle = 1,
  RoundRectangle = 2,
  Ellipse = 3
}
export class cfgDrawParameter  {
  drawParameteriD: string;
  TDOCID: number;
  userID: string;
  ParameterName: string;
  ParameterValue: string;
}

export class DrawParameterObj {
  parameterName: string;
  parameterValue: string;
}

export class LeadToolsHelper {
  FontSizes = [];
  Widths = [];
  enumFonts = [{name: 'Arial', value: 0}, {name: 'Verdana', value: 1}, {name: 'Calibri', value: 2}, {name: 'Tahoma', value: 3}];
  enumFontStyles = [{name: 'Regular', value: 0}, {name: 'Bold', value: 1}, {name: 'Italic', value: 2}, {name: 'Underline', value: 3}, {name: 'Strikethrough', value: 4}];
  enumStampLocations = [{name: 'None', value: 0}, {name: 'Upper Left', value: 1}, {name: 'Upper Right', value: 2}, {name: 'Bottom Left', value: 3}, {name: 'Bottom Right', value: 4}];
  enumShapes = [{name: 'None', value: 0}, {name: 'Rectangle', value: 1}, {name: 'Round Rectangle', value: 2}, {name: 'Ellipse', value: 3}];
  enumCaps = [{name: 'Flat', value: 0}, {name: 'Square', value: 1}, {name: 'Round', value: 2}, {name: 'Triangle', value: 3}];

  constructor() {
    for (let i = 6; i <= 25; i++) {
      const newSize = {
        value: i
      };
      this.FontSizes.push(newSize);
    }

    for (let i = 6; i <= 25; i++) {
      const newSize = {
        value: i
      };
      this.FontSizes.push(newSize);
    }
    for (let i = 1; i <= 20; i++) {
      const newSize = {
        value: i
      };
      this.Widths.push(newSize);
    }
  }

  getFont(fontStdStamp: any) {
    const val = this.enumFonts.find(p => p.value.toString() === fontStdStamp.toString());
    if (val) {
      return val;
    }
  }

  getFontSize(fontSizeStdStamp: number) {
    const val = this.FontSizes.find(p => p.value === fontSizeStdStamp);
    if (val) {
      return val;
    }
  }

  getFontStyle(fontStyleStdStamp: string) {
    const val = this.enumFontStyles.find(p => p.value.toString() === fontStyleStdStamp.toString());
    if (val) {
      return val;
    }
  }

  getWidth(lineWidthTxt: any) {
    const val = this.Widths.find(p => p.value.toString() === lineWidthTxt.toString());
    if (val) {
      return val;
    }
  }

  getShape(shape: any) {
    const val = this.enumShapes.find(p => p.value.toString() === shape.toString());
    if (val) {
      return val;
    }
  }

  getLineCap(lineStartCap: any) {
    const val = this.enumCaps.find(p => p.value.toString() === lineStartCap.toString());
    if (val) {
      return val;
    }
  }
}

export class AnnotationDefaults  {
  font: string;
  fontName: string;
  fontSize: number;
  fontStyle: number;
  strokeColor: string;
  strokeWidth: number;
  lineStartCap: number;
  lineEndCap: number;
  fillColor: string;
}

export class DrawingToolsDefaults {
  useRatioArrowLen: boolean;
  arrowLength: number;
  fillArrowhead: boolean;
}

export class DrawStampDefaults {
  //Standard Stamp
  fontStdStamp: number;
  fontNameStdStamp: string;
  fontSizeStdStamp: number;
  fontStyleStdStamp: string;
  foregroundStdStamp: string;
  backgroundStdStamp: string;
  locationStdStamp: string;
  //Custom Stamp
  fontCustomStamp: number;
  fontNameCustomStamp: string;
  fontSizeCustomStamp: number;
  fontStyleCustomStamp: string;
  foregroundCustomStamp: string;
  backgroundCustomStamp: string;
}

export class DrawTextDefaults {
  //Text
  fontTxt: number;
  fontNameTxt: string;
  fontSizeTxt: number;
  fontStyleTxt: string;
  foregroundTxt: string;
  backgroundTxt: string;
  borderColorTxt: string;
  lineWidthTxt: number;
  //Text Pointer
  fontTxtPtr: number;
  fontNameTxtPtr: string;
  fontSizeTxtPtr: number;
  fontStyleTxtPtr: string;
  foregroundTxtPtr: string;
  backgroundTxtPtr: string;
  borderColorTxtPtr: string;
  lineWidthTxtPtr: number;
}

export class DrawFunctionDefaults {
  font: string;
  fontName: string;
  fontSize: number;
  fontStyle: string;
  foreground: string;
  background: string;
  showTickMarks: boolean;
  showGauge: boolean;
}
export class DrawMagnificationDefaults {
  shape: string;
  width: number;
  height: number;
  borderColor: string;
  borderWidth: number;
  lineStartCap: string;
  lineEndCap: string;
  hasCrosshairs: boolean;
  crosshairsColor: string;
  crosshairWidth: number;
  scaleFactor: number;
}
export class DrawCanvasDefaults {
  startColor: string;
  endColor: string;
  width: number;
  height: number;
  gradientStyle: number;
  gradientStep: number;
}
export class DrawSharpnessDefaults {
  sharpness: number;
  adjustmentFactor: number;
  radius: number;
  threshold: number;
}

